export default {
  title: 'Congratulations! You just earned {{value}} points 🥳',
  balance: 'My points <highlight>{{value}}p ({{moneyValue}})</highlight>',
  description: 'Redeem your points on your next order',
  guest_description:
    'You earned <highlight>{{value}} points ({{moneyValue}})</highlight> discount for your next order! 🤩',
  buttons: {
    ok: 'Okay',
    claim: 'Login and claim points',
  },
};
